import gatewayNameListSaga from "./gateway_name_list_saga";

const gatewayNameSaga = [gatewayNameListSaga];

export default gatewayNameSaga;
